import type React from "react";
import { X } from "lucide-react";
import { TransactionDetailsModalProps } from "../../../../interface/interfaces";
import { formatCurrency } from "../../../../utils/utils";

const TransactionDetailsModal: React.FC<TransactionDetailsModalProps> = ({
  transaction,
  isOpen,
  onClose,
}) => {
  if (!isOpen || !transaction) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-full max-w-2xl max-h-[90vh] overflow-auto bg-white rounded-lg shadow-xl">
        <div className="sticky top-0 flex items-center justify-between p-4 border-b bg-white z-10">
          <h2 className="text-xl font-bold text-gray-900">
            Transaction Details
          </h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
          >
            <X className="h-6 w-6 text-gray-500" />
          </button>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium text-gray-500">Reference</h3>
                <p className="mt-1 text-base font-semibold">
                  {transaction.reference}
                </p>
              </div>

              <div>
                <h3 className="text-sm font-medium text-gray-500">Amount</h3>
                <p className="mt-1 text-base font-semibold">
                  {formatCurrency(transaction.amount, transaction.currency)}
                </p>
              </div>

              <div>
                <h3 className="text-sm font-medium text-gray-500">Status</h3>
                <div className="mt-1">
                  <span
                    className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${
                      transaction.status === "SUCCESSFUL"
                        ? "bg-green-100 text-green-800"
                        : transaction.status === "FAILED"
                        ? "bg-red-100 text-red-800"
                        : "bg-yellow-100 text-yellow-800"
                    }`}
                  >
                    {transaction.status}
                  </span>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium text-gray-500">Narration</h3>
                <p className="mt-1 text-base">{transaction.narration}</p>
              </div>
            </div>
          </div>

          {transaction.settlementReference && (
            <div className="mt-6 pt-6 border-t">
              <h3 className="text-sm font-medium text-gray-500">
                Settlement Reference
              </h3>
              <p className="mt-1 text-base">
                {transaction.settlementReference}
              </p>
            </div>
          )}

          {transaction.settlementDate && (
            <div className="mt-4">
              <h3 className="text-sm font-medium text-gray-500">
                Settlement Date
              </h3>
              <p className="mt-1 text-base">{transaction.settlementDate}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TransactionDetailsModal;
